import React from 'react'
import classnames from 'classnames/bind'

// Libs
import { useMemberLiveList } from '@/hooks/useMemberLiveList'

// Components
import LiveList from '@/components/shared/LiveList'
import Empty from '@/components/shared/Empty'
import HotLiveList from '@/components/shared/HotLiveList'

// Constants
import { GTM_LOCATION } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export const LiveContent = ({ memberInfoId, liveTypes, isDrawer }: { memberInfoId: any; liveTypes: string; isDrawer?: boolean }) => {
  const liveContents = useMemberLiveList({ pageSize: 20, memberInfoId: memberInfoId, liveTypes })
  const memberLiveLists = liveContents?.data?.pages[0].roomList || []

  const hasMemberLiveList = memberLiveLists.length > 0

  return (
    <div className={cx('live', { isDrawer })}>
      {hasMemberLiveList && (
        <div className={cx('live__list')}>
          <LiveList liveListData={liveContents} gtmLocation={GTM_LOCATION.USER_PROFILE} />
        </div>
      )}

      {liveContents.isSuccess && !hasMemberLiveList && <Empty />}

      {liveContents.isSuccess && !hasMemberLiveList && <HotLiveList />}
    </div>
  )
}

export default LiveContent
